#import "../fragments/people-iq-filter-settings-fragment.graphql"

mutation UpdatePeopleIqFilterSettings($input: PeopleIqFilterSettingsUpdateInput!) {
    peopleIqFilterSettingsUpdate(input: $input) {
        ...PeopleIqFilterSettingsFragment
    }
}
